import store from '../../store'

let role = 'coordinator'

export default {
  role,
  guard: () => store.getters['auth/isCoordinator'],
  items: [
    {
      label: 'Carico Prodotti',
      name: `Warehouses`,
      items: []
    },
    {
      label: 'Firma',
      name: `Presence`,
      items: []
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/navigator/coordinator.js